import React, { useState, useCallback } from "react";
import { sendOperatorFeedback } from "../services/feedbacks";
import "../styles/operator-support.css";

const SupportOperator = () => {
    const [messageText, setMessageText] = useState("");
    const [requestAccountDeletion, setRequestAccountDeletion] = useState(false);
    const [statusMessage, setStatusMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSendMessage = useCallback(async () => {
        setStatusMessage("");

        if (!messageText.trim()) {
            setStatusMessage("❌ Будь ласка, введіть повідомлення");
            return;
        }

        setLoading(true);

        try {
            await sendOperatorFeedback({
                message: messageText,
                requestAccountDeletion,
            });

            setStatusMessage("✅ Повідомлення успішно відправлено. Ми звернемося до вас найближчим часом.");
            setMessageText("");
            setRequestAccountDeletion(false);
        } catch (error) {
            setStatusMessage(`❌ ${error.message}`);
        } finally {
            setLoading(false);
        }
    }, [messageText, requestAccountDeletion]);

    return (
        <div className="support-page">
            <p className="support-page__lead">
                Маєте запитання або потребуєте допомоги? Напишіть нам свій запит нижче.
            </p>

            <div className="support-form">
                <label className="support-label">
                    <span>Ваше повідомлення</span>
                    <textarea
                        className="support-textarea"
                        value={messageText}
                        onChange={(e) => setMessageText(e.target.value)}
                        placeholder="Опишіть вашу проблему або задайте питання..."
                        rows={6}
                        disabled={loading}
                    />
                </label>

                <div className="support-check-card">
                    <input
                        type="checkbox"
                        id="account-deletion-request"
                        checked={requestAccountDeletion}
                        onChange={(e) => setRequestAccountDeletion(e.target.checked)}
                        disabled={loading}
                    />
                    <label htmlFor="account-deletion-request">
                        <strong>Запросити видалення акаунту та персональних даних</strong>
                        <p>Встановіть цей прапорець, якщо хочете видалити свій акаунт та всі пов&apos;язані з ним дані.</p>
                    </label>
                </div>

                {requestAccountDeletion ? (
                    <div className="support-warning">
                        <strong>Важливо:</strong> Видалення акаунту є постійною дією. Всі ваші дані будуть видалені протягом 5–7 робочих днів. Ви отримаєте підтвердження на електронну пошту.
                    </div>
                ) : null}

                {statusMessage ? (
                    <div className={`support-status ${statusMessage.includes("❌") ? "is-error" : "is-ok"}`}>
                        {statusMessage}
                    </div>
                ) : null}

                <button
                    type="button"
                    className="support-send-btn"
                    onClick={handleSendMessage}
                    disabled={loading}
                >
                    {loading ? "Відправлення..." : "Надіслати повідомлення"}
                </button>
            </div>

            <div className="support-tips-card">
                <h4>Поради</h4>
                <ul>
                    <li>Опишіть вашу проблему якомога детальніше</li>
                    <li>Укажіть послідовність дій, яка привела до проблеми</li>
                    <li>Скиньте скріншоти помилок (якщо це можливо)</li>
                    <li>Очікуйте на відповідь протягом 24–48 годин</li>
                </ul>
            </div>
        </div>
    );
};

export default SupportOperator;
